import {
    useTranslator,
    useUrlLocalizer,
    useCurrentLanguage
} from 'tradera/lang/translate';
import { isSwedishOrUndefined } from 'tradera/localization/languagecode';
import { HOVER_MENUS } from './hover-menu/constants';
import HoverMenu from './hover-menu/hover-menu';
import * as MenuItem from 'tradera/components/menu-item/menu-item';
import { Button } from 'tradera/components/atoms/button/button';
import { classNames } from 'tradera/utils/class-names';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';

type HowTraderaWorksProps = {
    mouseOut: () => void;
    mouseOver: (menu: string) => void;
    showMenu: boolean;
};

export const HowTraderaWorks = ({
    mouseOut,
    mouseOver,
    showMenu
}: HowTraderaWorksProps) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const { language } = useCurrentLanguage();

    const isSwedish = isSwedishOrUndefined(language);

    return (
        <div
            onMouseLeave={mouseOut}
            onMouseEnter={() => mouseOver(HOVER_MENUS.HOW_TRADERA_WORKS)}>
            <Button
                theme="text"
                className={classNames('slim-header__button d-none d-md-flex', {
                    active: showMenu
                })}
                href={toLocalizedUrl('/how-to-buy')}>
                <InfoIcon className="icon icon-md d-block d-xl-none" />
                <span className="d-none d-xl-inline slim-header__link-text">
                    {t('siteHeader_howTo_v2')}
                </span>
            </Button>
            <HoverMenu showMenu={showMenu}>
                <MenuItem.Wrapper>
                    <MenuItem.Button
                        href={toLocalizedUrl('/how-to-buy')}
                        className="px-2"
                        brandColorOnHover
                        {...{
                            'data-ga-category': 'Top navigation',
                            'data-ga-action': 'How to buy',
                            'data-ga-label': 'Link - How to buy'
                        }}>
                        {t('siteHeader_howToBuy_v2')}
                    </MenuItem.Button>
                    <MenuItem.Button
                        href={toLocalizedUrl('/how-to-sell')}
                        className="px-2"
                        brandColorOnHover
                        {...{
                            'data-ga-category': 'Top navigation',
                            'data-ga-action': 'How to sell',
                            'data-ga-label': 'Link - How to sell'
                        }}>
                        {t('siteHeader_howToSell_v2')}
                    </MenuItem.Button>
                    {isSwedish && (
                        <MenuItem.Button
                            href={'https://business.tradera.com/'}
                            className="px-2"
                            border={false}
                            brandColorOnHover
                            {...{
                                'data-ga-category': 'Top navigation',
                                'data-ga-action': 'How to sell company',
                                'data-ga-label': 'Link - How to sell company'
                            }}>
                            {t('siteHeader_howToSellCompany')}
                        </MenuItem.Button>
                    )}
                </MenuItem.Wrapper>
            </HoverMenu>
        </div>
    );
};
